import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { TaskAPI, ProjectAPI } from '../lib/api';
import { Table, Thead, Tbody, Th, Tr } from '../components/ui/Table';
import { TaskRow } from '../components/TaskRow';
import { Button } from '../components/ui/Button';
import { Skeleton } from '../components/ui/Skeleton';
import { TopBar } from '../components/TopBar';
import { Select } from '../components/ui/Select';
import { Input } from '../components/ui/Input';

export function TasksPage() {
  const navigate = useNavigate();
  const [projectFilter, setProjectFilter] = useState('');
  const [tagFilter, setTagFilter] = useState('');
  const [enabledFilter, setEnabledFilter] = useState('');

  const params: Record<string, string> = {};
  if (projectFilter) params.project = projectFilter;
  if (tagFilter) params.tag = tagFilter;
  if (enabledFilter) params.enabled = enabledFilter;

  const { data: tasksData, isLoading } = useQuery({
    queryKey: ['tasks', params],
    queryFn: () => TaskAPI.list(params),
  });

  const { data: projectsData } = useQuery({
    queryKey: ['projects'],
    queryFn: () => ProjectAPI.list(),
  });

  const tasks: any[] = tasksData?.items ?? tasksData ?? [];
  const projects: any[] = projectsData?.items ?? projectsData ?? [];

  const projectOptions = [
    { value: '', label: 'Всі проєкти' },
    ...projects.map((p: any) => ({ value: p.slug || p.id, label: p.name })),
  ];

  const enabledOptions = [
    { value: '', label: 'Всі' },
    { value: 'true', label: 'Активні' },
    { value: 'false', label: 'Вимкнені' },
  ];

  return (
    <div>
      <TopBar
        title="Задачі"
        actions={
          <Button onClick={() => navigate({ to: '/tasks/new' })}>
            <Plus size={14} /> Нова задача
          </Button>
        }
      />
      <div className="p-6">
        <div className="flex flex-wrap gap-3 mb-4">
          <Select
            options={projectOptions}
            value={projectFilter}
            onChange={(e) => setProjectFilter(e.target.value)}
            className="w-44"
          />
          <Input
            placeholder="Тег..."
            value={tagFilter}
            onChange={(e) => setTagFilter(e.target.value)}
            className="w-36"
          />
          <Select
            options={enabledOptions}
            value={enabledFilter}
            onChange={(e) => setEnabledFilter(e.target.value)}
            className="w-32"
          />
        </div>

        {isLoading ? (
          <div className="space-y-2">
            {[1,2,3,4,5].map(i => <Skeleton key={i} className="h-12 w-full" />)}
          </div>
        ) : tasks.length > 0 ? (
          <Table>
            <Thead>
              <Tr>
                <Th>Назва</Th>
                <Th>Проєкт</Th>
                <Th>Розклад</Th>
                <Th>Тип</Th>
                <Th>Останній запуск</Th>
                <Th>Статус</Th>
                <Th>Вкл</Th>
                <Th>Дії</Th>
              </Tr>
            </Thead>
            <Tbody>
              {tasks.map((task: any) => (
                <TaskRow key={task.id} task={task} />
              ))}
            </Tbody>
          </Table>
        ) : (
          <div className="text-center py-12 text-tg-text-secondary">
            Задачі не знайдені
          </div>
        )}
      </div>
    </div>
  );
}
